import { RouteShareService, TOOL_TYPE_WENNDANN } from "src/app/shared/services/route-share.service";
import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_COLORS, BlocklyToolboxCategory } from "../blocky-types.types";

export function BlocklyCategory_WENNDANN(name: string = "unnamed", BH: BlocklyHelperService, rss: RouteShareService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.WENNDANN, name: name, contents: [] };
  cat.contents = [
    BH.label("Wenn-Dann Werte"),
    BH.label("(nur nutzbar in Wenn-Dann Logiken)"),
    BH.withNested(
      BH._custom("IFTHEN_COUNTER", "@output:Number\nAnzahl Ausführungen für {{skill[@check=SKILL]}}", "skill[{{skill}}+'_count']", { colour: BLOCKLY_COLORS.PROPERTIES, inputsInline: true }),
      [{ forValue: "skill", isShadow: true, targetBlockType: 'BLOCK_STACK_SKILL' }]
    ),
    BH.propertyDropdown("GLOBAL_VAR", "Globale Variable", [
      ["Bot Name", "conf.botName"],
      ["Bot Farbe", "conf.botColor"],
      ["Thread ID", "conf.triggerHistoryItemId"],
      ["Thread Inhalt", "conf.triggerHistoryItemContent"],
      ["Thread OpenAi ID", "conf.triggerHistoryItemOpenAiThreadId"]
    ])
  ];
  rss.getToolsByType(TOOL_TYPE_WENNDANN).forEach((wd) => {
    if (wd.skillId !== '' && wd.params.length > 0) {
      const options: [string, string][] = [];
      wd.params.forEach((wdparam) => {
        options.push([wdparam.key, 'vars.' + wdparam.key]);
      });
      cat.contents?.push(BH.propertyDropdown(
        "if_then_" + wd.id,
        wd.skillId,
        options,
        undefined,
        `Gibt einen der Parameterwerte zurück, die dem Wenn-Dann-Skill „${wd.skillId}" beim Auslösen übergeben wurden. Wähle über das Dropdown-Feld aus, welcher der übergebenen Werte verwendet werden soll.`
      ));
    }
  });
  return cat;
}
